module.exports = __webpack_public_path__ + "static/media/herdy-picking-some-apples.c8cb0292.svg";